import { EntityDetails } from "../interfaces/entity-details.interface";
// matches C# EntityDetails and Entity poco
export class BaseEntityDetails implements EntityDetails {
    masterId!: number;
    name!: string;
    reportingPeriod!: string;
    qtdGain!: number | null;
    itdGain!: number | null;
    commitment!: number | null;
    contributions!: number | null;
    distributions!: number | null;
    totalValue!: number | null;
    nav!: number | null;
    priorNAV!: number | null;
    remainingCommitment!: number | null;
    irr!: number | null;
    priorIrr!: number | null;
    tvpi!: number | null;
    priorTvpi!: number | null;
    qoQTvpiChange!: number | null;
    qoQIrrChange!: number | null;
    qoQContributions!: number | null;
    qoQDistributions!: number | null;
    qoQAdjustedNAV!: number | null;
    qoQGainLoss!: number | null;
    currency!: string;
    publishValuationType!: string;
    subsequentContributions!: number | null;
    subsequentDistributions!: number | null;
    reportedValue!: number | null;
    reportedContributions!: number | null;
    reportedDistributions!: number | null;
    fxGainLoss!: number | null;
}
